<!--
 * @Author: cryi.liu
 * @Date: 2020-07-13 11:45:13
 * @LastEditTime: 2020-07-16 17:55:30
 * @Description: 上传 Excel 添加考试对象
-->
<template>
  <div class="add-exam-object-by-excel">
    <i-upload
      type="drag"
      :class="canAddExamObjectForUploadExcel ? '' : 'disabled'"
      accept=".xls,.xlsx"
      :format="['xls', 'xlsx']"
      :show-upload-list="false"
      :disabled="!canAddExamObjectForUploadExcel"
      :headers="{ psstoken: token }"
      :data="{ paperId }"
      name="file"
      action="/examcentersite/paper/upload/user"
      :on-format-error="uploadFileFormatError"
      :before-upload="examObjectExcelBeforeUpload"
      :on-success="examObjectExcelUploaded"
      :on-error="examObjectExcelUploadErro">
        <div style="padding: 40px 0">
          <i-icon type="ios-cloud-upload" size="52" style="color: #3399ff" />
          <p>点击或拖拽文件到此处上传考试对象</p>
        </div>
    </i-upload>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'AddExamObjectByExcel',
  computed: {
    ...mapGetters({
      token: 'authStore/token',
      paperId: 'createPaperStore/paperId',
      canAddExamObjectForUploadExcel: 'createPaperStore/canAddExamObjectForUploadExcel',
    }),
  },
  methods: {
    ...mapActions({
      setProcessingShowState: 'pageStore/invokeSetProcessingShowState',
      setExamObjectList: 'createPaperStore/invokeSetExamObjectList',
      setExamObjectTotal: 'createPaperStore/invokeSetExamObjectTotal',
      setCanAddExamObject: 'createPaperStore/invokeSetCanAddExamObject',
      setCanAddExamObjectForUploadExcel: 'createPaperStore/invokeSetCanAddExamObjectForUploadExcel',
    }),
    /**
     *  考试对象 Excel 上传之前钩子函数
     */
    examObjectExcelBeforeUpload() {
      this.setProcessingShowState({ show: true });
    },
    /**
     * 文件格式校验错误
     */
    uploadFileFormatError() {
      alert('上传文件格式未支持');
      this.setProcessingShowState({ show: false });
    },
    /**
     * 通过上传 Excel 添加考试对象成功
     */
    examObjectExcelUploaded(result) {
      if (result.code === '200') {
        const examObjectList = [
          {
            staffType: '--',
            branch: '--',
            subBranch: '--',
            channel: '--',
            compoChannel: '--',
            groupName: '--',
            userType: '--',
            userTypeDetail: '--',
            starLevel: '--',
            hrMainGroup: '--',
            count: result.data.total,
          },
        ];

        this.setExamObjectList({ examObjectList });
        this.setExamObjectTotal({ examObjectTotal: result.data.total });

        this.setCanAddExamObjectForUploadExcel({ canAddExamObjectForUploadExcel: false });
        this.setCanAddExamObject({ canAddExamObject: false });

        alert('通过Excel添加考试对象成功');
      } else {
        alert(result.msg);
      }

      this.setProcessingShowState({ show: false });
    },
    /**
     * 通过上传 Excel 添加考试对象失败
     */
    examObjectExcelUploadErro() {
      alert('通过Excel添加考试对象失败');
      this.setProcessingShowState({ show: false });
    },
  },
};
</script>

<style lang="less" scoped>
.add-exam-object-by-excel {
  width: 100%;

  > .disabled {
    /deep/ .ivu-upload {
      cursor: no-drop;
    }

    /deep/ .ivu-upload-drag:hover {
      border: 1px dashed #dcdee2;
    }
  }
}
</style>
